import http from "@/shared/services/http";

export const createDistrictV21 = (data: any) => http.post(`v1/regions/districts/create`, data);
export const singleDistrictV21 = (id: number) => http.get(`v1/regions/districts/single/${id}`);
export const editDistrictV21 = (data: any) => http.put(`v1/regions/districts/edit/${data.id}`, data);
export const listDistrictV21 = (params: any = {}) => http.get(`v1/regions/districts/list`, { params });
export const deleteDistrictV21 = (id: number) => http.delete(`v1/regions/districts/delete/${id}`);
